export default {
  state: {
    list: [],
    draft: [],
    answers: [],
    types: {
      single: 'Single choice',
      multiple: 'Multiple choice',
      sort: 'Sortable question',
      text: 'Enter answer text',
      number: 'Enter number',
      float: 'Enter a fractional number',
      concentration: 'Concentration',
      measure: 'Measure',
      text_block: 'Text block',
    }
  },
  mutations: {
    setQuestions(state, payload) {
      state.list = payload
    },
    setDraftQuestions(state, payload) {
      state.draft = payload
    },
    setQuestionAnswers(state, payload) {
      state.answers = payload
    },
  },
  actions: {
    queryQuestions({dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'questions')
        .then(res => {
          commit('setQuestions', res.data)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    queryDraftQuestions({dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'questions/draft')
        .then(res => {
          commit('setDraftQuestions', res.data)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    storeQuestion({dispatch, getters}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'questions', payload)
        .then(res => {
          if (payload.poll_id) {
            dispatch('querySurvey', payload.poll_id).then(() => {
              setTimeout(() => { // todo костыль
                dispatch('sortableQuestions', getters.getSurveyForm.questions)
              }, 500)
            })
          } else if (payload.is_draft) {
            dispatch('queryDraftQuestions')
          } else {
            dispatch('queryQuestions')
          }
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    storeUseQuestion({dispatch, getters}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'questions/store-use', payload)
        .then(res => {
          if (payload.poll_id) {
            dispatch('querySurvey', payload.poll_id).then(() => {
              setTimeout(() => { // todo костыль
                dispatch('sortableQuestions', getters.getSurveyForm.questions)
              }, 500)
            })
          } else if (payload.is_draft) {
            dispatch('queryDraftQuestions')
          } else {
            dispatch('queryQuestions')
          }
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    updateQuestion({dispatch, state}, payload) {
      dispatch('setPreloader', true)
      axios.patch(process.env.VUE_APP_API_ENDPOINT + 'questions/' + payload[0], payload[1])
        .then(res => {
          if (payload[1].poll_id)
            dispatch('querySurvey', payload[1].poll_id)
          else if (payload[1].is_draft)
            dispatch('queryDraftQuestions')
          else
            dispatch('queryQuestions')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    deleteQuestion({commit, dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'questions/' + payload.id)
        .then(res => {
          if (payload.poll_id)
            dispatch('querySurvey', payload.poll_id)
          else if (payload.is_draft)
            dispatch('queryDraftQuestions')
          else
            dispatch('queryQuestions')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    queryQuestionAnswers({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'questions/' + payload)
        .then(res => {
          commit('setQuestionAnswers', res.data.question.answers)
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    deleteAnswer({commit, dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'questions/answer/' + payload.id)
        .then(res => {
          dispatch('queryQuestions')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    sortableQuestions({commit, dispatch}, payload) {
      let sort_ids = []
      for (let i = 0; i < payload.length; i++) {
        sort_ids.push(payload[i].id)
      }
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'questions/sort', {sort: sort_ids})
        .then(res => {
          dispatch('queryQuestions')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    syncQuestions({commit, dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'questions/sync/' + payload)
        .then(res => {
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    syncCurrentQuestion({commit, dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'question/sync/' + payload)
        .then(res => {
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
  },
  getters: {
    getQuestions: state => {
      return state.list
    },
    getQuestionTypes: state => {
      return state.types
    },
    getDraftQuestions: state => {
      return state.draft
    },
    getQuestionAnswers: state => {
      return state.answers
    },
  }
}